import React from 'react'
import ReactDOM, {createRoot} from 'react-dom/client'
import App from './App'
import {ChakraProvider} from "@chakra-ui/react";
import {EvoContextProvider} from "./context/evo.context";




const domNode = document.getElementById('root')!;
const root = createRoot(domNode);

root.render(
	// <React.StrictMode>
	<EvoContextProvider>
		<ChakraProvider>
				<App />
		</ChakraProvider>
	</EvoContextProvider>,
	// </React.StrictMode>,
);